import React, {useState} from "react";
import database, {signInWithGoogle} from '../firebase';
import "./Login.css";
import { useHistory } from "react-router-dom";

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [English, setEnglish] = useState(true);
    const history = useHistory();
    

    const handleLogin =() =>{
        database.auth().signInWithEmailAndPassword(email,password)
            .then(()=>{
                var user = database.auth().currentUser;
                setEmail("");
                setPassword("");
                const path = `/${user.uid}`;
                history.push(path);
            }).catch((err)=>{
                setEmail("");
                setPassword("");
                alert(err);
        });
    }

    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }

    return (
        <div> 
            {English?(
                <>
                <div className="Login">
                <h1> Login Page</h1>
                <div className="Login-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>
                
                <div className="Login-box">
                <label style={{marginTop:'40px'}}>Email：</label>
                <input type="text" required value={email}
                    placeholder = "   Email" style={{marginTop:'45px'}}
                    onChange={(e) => setEmail(e.target.value)}
                /><br/>

                <label style={{marginTop:'30px'}}>Password：</label>
                <input type="password" required value={password}
                    placeholder = "   Password" style={{marginTop:'75px'}}
                    onChange={(e) => setPassword(e.target.value)}
                /><br/>

                <button onClick={handleLogin}><h6>Login</h6> </button><br/>
                </div>
                </div>
                </>
            ):(
                <div className="Login">
                <h1> 登入页面</h1>
                <div className="Login-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                
                <div className="Login-box">
                <label style={{marginTop:'40px'}}>邮箱：</label>
                <input type="text" required value={email}
                    placeholder = "   邮箱" style={{marginTop:'45px'}}
                    onChange={(e) => setEmail(e.target.value)}
                /><br/>

                <label style={{marginTop:'30px'}}>密码：</label>
                <input type="password" required value={password}
                    placeholder = "   密码" style={{marginTop:'75px'}}
                    onChange={(e) => setPassword(e.target.value)}
                /><br/>

                <button onClick={handleLogin}><h6>登入</h6> </button><br/>
                <button onClick={signInWithGoogle}><h6>登入Google</h6> </button><br/>
                </div>
                </div>
            )}
        </div>  
        
    );
     
}